define('presentation/settings/accountProfile/presentationObjects/accountProfileBusinessPresentationObject',[],function() {
    return function() {
        const self = this;
        self.accountHolderFirstName = null;
        self.accountHolderLastName = null;
        self.businessName = null;
        self.companySize = null;
    };
});
